<template>
    <div>
        <!--快捷注册第一步-->
        <Modal v-model="modalStatus" width="24%" :mask-closable="false">
            <div slot="close" class="close-btn">
                <Icon
                    type="close-round"
                    @click="handleClose"
                    color="#5c6b77"
                    size="15"
                ></Icon>
            </div>
            <div class="login-header">个人注册</div>
            <Form ref="registerOneForm" :model="params" :rules="rule">
                <Row>
                    <FormItem prop="account">
                        <Input
                            v-model.trim="params.account"
                            placeholder="请输入手机号码"
                        >
                            <Icon
                                type="android-phone-portrait"
                                slot="prepend"
                                size="16"
                                color="#5c6b77"
                            ></Icon>
                        </Input>
                    </FormItem>
                </Row>

                <Row>
                    <Col span="18">
                        <FormItem prop="smsCode">
                            <Input
                                v-model.trim="params.smsCode"
                                placeholder="请输入短信验证码"
                            >
                                <Icon
                                    type="android-textsms"
                                    slot="prepend"
                                    size="16"
                                    color="#5c6b77"
                                ></Icon>
                            </Input>
                        </FormItem>
                    </Col>
                    <Col span="3">
                        <Button
                            type="primary"
                            style="margin-left: 3%"
                            :loading="sendCodeBtnDisabled"
                            @click="handleVerifyCodeBtn"
                        >
                            <span v-if="!sendCodeBtnDisabled">获取验证码</span>
                            <span v-else>{{ sendCodeTimeCount }}秒</span>
                        </Button>
                    </Col>
                </Row>
                 <!-- <Row>
                    <span style="margin-bottom: 14px;display: block;color: #ed3f14;">默认初始密码：123456</span>
                </Row> -->
                <div class="resister-forget-pwd clear_fix">
                    <div class="f_left">
                        <span class="register-txt" @click="loginModalShow"
                            >立即登录</span
                        >
                    </div>
                    <!--<div class="register-txt f_right" @click="resetPasswordModalShow">忘记密码?</div>-->
                </div>
            </Form>
            <div slot="footer">
                <Button
                    type="primary"
                    @click="handleNext"
                    class="login-btn"
                    long
                    >注册</Button
                >
            </div>
        </Modal>

        <!--滑动验证-->
        <verfy ref="verfy" @success="verifySuccess"></verfy>
    </div>
</template>
<script>
import { postSendSms } from "../api/user.js";
import verfy from "../components/Verify.vue";
import mtils from "mtils";
export default {
    components: {
        verfy,
    },
    data() {
        //校验手机号码
        const validateMobile = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("手机号码不能为空"));
            }
            if (!mtils.validation.isMobile(value)) {
                return callback(new Error("手机号码格式不正确"));
            }
            callback();
        };
        return {
            //注册信息
            params: {
                account: "",
                smsCode: "",
                isBusiness: false,
            },
            sendCodeBtnDisabled: false,
            sendCodeTimeCount: 0,
            sendCodeTimer: null,
            //注册校验
            rule: {
                account: [
                    {
                        required: true,
                        message: "手机号码不可为空",
                        trigger: "blur",
                    },
                    {
                        validator: validateMobile,
                        trigger: "blur",
                    },
                ],
                smsCode: [
                    {
                        required: true,
                        message: "验证码不可为空",
                        trigger: "blur",
                    },
                ],
            },
            //register模态框
            modalStatus: false,
        };
    },
    watch: {
        modalStatus(val) {
            if (!val) {
                clearInterval(this.sendCodeTimer);
                this.sendCodeBtnDisabled = false;
                this.sendCodeTimeCount = 0;
                this.$refs["registerOneForm"].resetFields();
            }
        },
    },
    methods: {
        loginModalShow() {
            this.modalStatus = false;
            this.$refs["registerOneForm"].resetFields();
            this.$emit("loginModalShow");
        },

        handleClose() {
            this.modalStatus = false;
            this.$refs["registerOneForm"].resetFields();
        },

        async handleVerifyCodeBtn(rule, value, callback) {
            let patternAccount =
                /^[1][3-9]\d{9}$|^([6|9])\d{7}$|^[0][9]\d{8}$|^[6]([8|6])\d{5}$/;
            if (!this.params.account) {
                this.$Message.info("手机号码不可为空!");
            } else if (!patternAccount.test(this.params.account)) {
                this.$Message.info("手机号码格式错误!");
            } else {
                this.$refs.verfy.Show();
            }
        },

        //验证码通过
        verifySuccess() {
            this.sendCodeBtnDisabled = true;
            this.sendCodeTimeCount = 60;
            postSendSms(this.params.account).then((res) => {
                if (res.code == 200) {
                    this.sendCodeTimer = setInterval(() => {
                        this.sendCodeTimeCount = this.sendCodeTimeCount - 1;
                        if (this.sendCodeTimeCount < 0) {
                            this.sendCodeBtnDisabled = false;
                            clearInterval(this.sendCodeTimer);
                        }
                    }, 1000);
                } else {
                    this.$Message.error("验证码获取错误");
                }
            });
        },

        handleNext() {
            this.$refs["registerOneForm"].validate((valid) => {
                if (valid) {
                    this.$emit("handleRegister", this.params);
                    // this.$emit("ModalTwoRegShow", this.params.account);
                    // this.modalStatus = false;
                }
            });
        },
    },
};
</script>
<style scoped>
.login-header {
    height: 98px;
    line-height: 98px;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #333;
}

.register-txt {
    color: #2d8cf0;
    cursor: pointer;
}

.register-txt:hover {
    color: #2d8cf0;
}
</style>


// WEBPACK FOOTER //
// src/components/ModalOneReg.vue